import React, {useEffect, useState} from 'react';
import {Alert, Button, Form, Spinner} from 'react-bootstrap';
import {authFetch} from '../utils/authFetch';

const pageSize = 30;
export default function ClientFilter({value, onChange, disabled, field='client', label='Clienți'}) {
 const [query,setQuery]=useState(''),[offset,setOffset]=useState(0);
 const [result,setResult]=useState(null),[loading,setLoading]=useState(false),[error,setError]=useState('');
 useEffect(()=>{
  let active=true;
  setResult(null);setError('');setLoading(true);
  const timer=setTimeout(()=>{
   const p=new URLSearchParams({search:query.trim(),skip:String(offset),limit:String(pageSize)});
   authFetch(`/distributie/filtre/${field}?${p}`).then(r=>{if(active)setResult(r);})
    .catch(e=>{if(active)setError(e.message);}).finally(()=>{if(active)setLoading(false);});
  },300);
  return ()=>{active=false;clearTimeout(timer);};
 },[query,offset,field]);
 const selected=new Set(value.map(c=>String(c.id)));
 const toggle=c=>onChange(selected.has(String(c.id))?value.filter(v=>String(v.id)!==String(c.id)):[...value,c]);
 return <div className="mt-3">
  <Form.Label htmlFor={`distribution-${field}-search`}>{label}</Form.Label>
  <Form.Control id={`distribution-${field}-search`} placeholder="Caută după denumire sau cod" value={query} disabled={disabled}
   onChange={e=>{setQuery(e.target.value);setOffset(0);}}/>
  <small className="text-muted">Căutare în tot nomenclatorul firmei, independent de perioada raportului. Fără selecție = toate pozițiile.</small>
  {value.length>0&&<div className="d-flex flex-wrap gap-2 my-2" aria-label={`${label} — selecție`}>{value.map(c=><Button key={c.id} size="sm" variant="outline-primary" disabled={disabled} onClick={()=>toggle(c)} aria-label={`Elimină ${c.label}`}>{c.label} ×</Button>)}<Button size="sm" variant="link" disabled={disabled} onClick={()=>onChange([])}>Toate</Button></div>}
  {loading&&<div role="status"><Spinner size="sm"/> Se caută…</div>}
  {error&&<Alert variant="danger">{error}</Alert>}
  {result&&<><div className="border rounded p-2 mt-2" style={{maxHeight:180,overflowY:'auto'}}>{result.items.map(c=><Form.Check key={c.id} id={`distribution-${field}-${c.id}`} type="checkbox" checked={selected.has(String(c.id))} disabled={disabled} onChange={()=>toggle(c)} label={`${c.label}${c.code?' — '+c.code:''} (ID ${c.id})`}/>)}</div>
   {!result.items.length&&<p role="status">Nicio poziție găsită în nomenclator pentru această căutare.</p>}
   <div className="d-flex gap-2 align-items-center mt-1"><small>{result.total} rezultate</small>
    <Button size="sm" variant="link" disabled={disabled||offset===0} onClick={()=>setOffset(o=>Math.max(0,o-pageSize))}>Înapoi</Button>
    <Button size="sm" variant="link" disabled={disabled||offset+pageSize>=result.total} onClick={()=>setOffset(o=>o+pageSize)}>Înainte</Button></div></>}
 </div>;
}
